// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./corporate-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Clean Modern Dashboard Theme */

:root {
  /* Modern Dashboard Colors */
  --dashboard-primary: #6366f1;
  --dashboard-primary-light: #818cf8;
  --dashboard-secondary: #8b5cf6;
  --dashboard-accent: #f59e0b;
  --dashboard-success: #10b981;
  --dashboard-warning: #f59e0b;
  --dashboard-error: #ef4444;
  
  /* Background Colors */
  --dashboard-bg: #f8fafc;
  --dashboard-card-bg: #ffffff;
  --dashboard-sidebar-bg: #ffffff;
  
  /* Text Colors */
  --dashboard-text-primary: #1e293b;
  --dashboard-text-secondary: #64748b;
  --dashboard-text-muted: #94a3b8;
  
  /* Borders & Shadows */
  --dashboard-border: #e2e8f0;
  --dashboard-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --dashboard-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --dashboard-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  
  /* Spacing */
  --dashboard-space-1: 0.25rem;
  --dashboard-space-2: 0.5rem;
  --dashboard-space-3: 0.75rem;
  --dashboard-space-4: 1rem;
  --dashboard-space-5: 1.25rem;
  --dashboard-space-6: 1.5rem;
  --dashboard-space-8: 2rem;
  --dashboard-space-10: 2.5rem;
  --dashboard-space-12: 3rem;
  --dashboard-space-16: 4rem;
  
  /* Border Radius */
  --dashboard-radius-sm: 0.375rem;
  --dashboard-radius-md: 0.5rem;
  --dashboard-radius-lg: 0.75rem;
  --dashboard-radius-xl: 1rem;
  --dashboard-radius-2xl: 1.5rem;
}

/* Clean Dashboard Layout */
.clean-dashboard {
  display: flex;
  min-height: 100vh;
  background: var(--dashboard-bg);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Sidebar Styling */
.clean-sidebar {
  width: 280px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  display: flex;
  flex-direction: column;
  padding: var(--dashboard-space-6);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.05);
  position: relative;
}

.clean-sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.02) 0%, rgba(139, 92, 246, 0.02) 100%);
  pointer-events: none;
}

/* Mobile Header */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: var(--dashboard-bg-primary);
  border-bottom: 1px solid var(--dashboard-border);
  z-index: 1002;
  padding: 0 var(--dashboard-space-4);
  justify-content: space-between;
  align-items: center;
  backdrop-filter: blur(20px);
  box-shadow: var(--dashboard-shadow-sm);
}

.mobile-logo {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
}

.mobile-logo .brand-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  border-radius: var(--dashboard-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  font-weight: 700;
  box-shadow: var(--dashboard-shadow-md);
}

.mobile-logo .brand-text {
  font-size: 1rem;
  font-weight: 600;
  color: var(--dashboard-text-primary);
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: var(--dashboard-bg-secondary);
  border: 1px solid var(--dashboard-border);
  color: var(--dashboard-text-primary);
  font-size: 1.5rem;
  cursor: pointer;
  padding: var(--dashboard-space-2);
  border-radius: var(--dashboard-radius-md);
  transition: all 0.2s ease;
  z-index: 1003;
}

.mobile-menu-toggle:hover {
  background: var(--dashboard-bg-hover);
  border-color: var(--dashboard-primary);
}

.mobile-menu-toggle svg {
  width: 24px;
  height: 24px;
}

/* Mobile Sidebar */
.mobile-sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.mobile-sidebar-overlay.show {
  display: block;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-3);
  margin-bottom: var(--dashboard-space-8);
  padding-bottom: var(--dashboard-space-6);
  border-bottom: 1px solid var(--dashboard-border);
}

/* Brand Icon with enhanced gradient */
.brand-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  border-radius: var(--dashboard-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  box-shadow: var(--dashboard-shadow-md);
  position: relative;
  overflow: hidden;
}

.brand-icon::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.3) 50%, transparent 70%);
  transform: rotate(45deg);
  animation: shine 3s infinite;
}

@keyframes shine {
  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  50% { transform: translateX(100%) translateY(100%) rotate(45deg); }
  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
}

.brand-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--dashboard-text-primary);
  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Navigation */
.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-2);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-3);
  padding: var(--dashboard-space-3) var(--dashboard-space-4);
  border-radius: var(--dashboard-radius-lg);
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--dashboard-text-secondary);
  font-weight: 500;
  font-size: 0.875rem;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
}

.nav-item:hover {
  background: var(--dashboard-bg);
  color: var(--dashboard-text-primary);
}

.nav-item.active {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  box-shadow: var(--dashboard-shadow-md);
}

.nav-icon {
  font-size: 1.25rem;
}

/* User Profile in Sidebar */
.sidebar-user {
  margin-top: auto;
  padding-top: var(--dashboard-space-6);
  border-top: 1px solid var(--dashboard-border);
}

.user-profile {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-3);
  padding: var(--dashboard-space-3);
  border-radius: var(--dashboard-radius-lg);
  transition: background 0.2s ease;
}

.user-profile:hover {
  background: var(--dashboard-bg);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 0.875rem;
  box-shadow: var(--dashboard-shadow-md);
  border: 2px solid var(--dashboard-card-bg);
  position: relative;
  overflow: hidden;
}

.user-avatar::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, var(--dashboard-primary), var(--dashboard-secondary), var(--dashboard-accent));
  border-radius: 50%;
  z-index: -1;
  animation: rotate 3s linear infinite;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.user-info {
  flex: 1 1;
}

.user-name {
  font-weight: 600;
  color: var(--dashboard-text-primary);
  font-size: 0.875rem;
  margin: 0;
}

.user-role {
  font-size: 0.75rem;
  color: var(--dashboard-text-muted);
  margin: 0;
}

/* Main Content Area */
.dashboard-main {
  flex: 1 1;
  padding: var(--dashboard-space-8);
  overflow-y: auto;
}

/* Header */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--dashboard-space-8);
}

.header-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text-primary);
  margin: 0 0 var(--dashboard-space-3) 0;
  line-height: 1.2;
  display: block;
}

.header-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--dashboard-primary);
  margin: 0 0 var(--dashboard-space-3) 0;
  line-height: 1.3;
  display: block;
}

.header-description {
  font-size: 1rem;
  color: var(--dashboard-text-secondary);
  margin: 0;
  line-height: 1.4;
  display: block;
}

.header-actions {
  display: flex;
  gap: var(--dashboard-space-4);
  align-items: center;
}

/* Stats Cards */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--dashboard-space-6);
  margin-bottom: var(--dashboard-space-8);
}

.stat-card {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  padding: var(--dashboard-space-6);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-4);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
  border-color: var(--dashboard-primary);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: var(--dashboard-radius-xl);
  background: linear-gradient(135deg, var(--dashboard-bg) 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--dashboard-text-secondary);
  font-size: 1.5rem;
  flex-shrink: 0;
  border: 1px solid var(--dashboard-border);
  transition: all 0.3s ease;
}

.stat-icon.connected {
  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);
  color: white;
  border-color: var(--dashboard-success);
}

.stat-card:hover .stat-icon {
  transform: scale(1.1);
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border-color: var(--dashboard-primary);
}

.stat-card:hover .stat-icon.connected {
  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);
  color: white;
}

.stat-content {
  flex: 1 1;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text-primary);
  line-height: 1;
  margin-bottom: var(--dashboard-space-1);
}

.stat-label {
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text-primary);
  margin: 0 0 var(--dashboard-space-2) 0;
}

.stat-label {
  font-size: 0.875rem;
  color: var(--dashboard-text-secondary);
  margin: 0;
}

.stat-change {
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: var(--dashboard-space-2);
}

.stat-change.positive {
  color: var(--dashboard-success);
}

.stat-change.negative {
  color: var(--dashboard-error);
}

/* Content Grid */
.dashboard-content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--dashboard-space-6);
  margin-bottom: var(--dashboard-space-8);
}

/* Cards */
.dashboard-card {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  padding: var(--dashboard-space-6);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--dashboard-space-6);
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--dashboard-text-primary);
  margin: 0;
}

.card-action {
  font-size: 0.875rem;
  color: var(--dashboard-primary);
  text-decoration: none;
  font-weight: 500;
}

/* Quick Actions Section */
.quick-actions-section {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  padding: var(--dashboard-space-6);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--dashboard-space-4);
  margin-top: var(--dashboard-space-4);
}

.quick-action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--dashboard-space-3);
  padding: var(--dashboard-space-6) var(--dashboard-space-4);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid var(--dashboard-border);
  border-radius: var(--dashboard-radius-xl);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: var(--dashboard-text-primary);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.quick-action-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  transition: left 0.3s ease;
  z-index: 0;
}

.quick-action-btn:hover::before {
  left: 0;
}

.quick-action-btn:hover {
  color: white;
  border-color: var(--dashboard-primary);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.25);
}

.action-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  border-radius: var(--dashboard-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.quick-action-btn:hover .action-icon {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.quick-action-btn span {
  font-size: 0.875rem;
  font-weight: 600;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

/* Activity Section */
.activity-section {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  padding: var(--dashboard-space-6);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-3);
  margin-top: var(--dashboard-space-4);
}

.activity-item {
  display: flex;
  align-items: flex-start;
  gap: var(--dashboard-space-4);
  padding: var(--dashboard-space-4);
  border-radius: var(--dashboard-radius-lg);
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.activity-item:hover {
  background: var(--dashboard-bg);
  border-color: var(--dashboard-border);
  transform: translateX(4px);
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--dashboard-bg);
  color: var(--dashboard-text-secondary);
  flex-shrink: 0;
  border: 1px solid var(--dashboard-border);
}

.activity-icon.connected {
  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);
  color: white;
  border-color: var(--dashboard-success);
}

.activity-content {
  flex: 1 1;
  min-width: 0;
}

.activity-title {
  font-weight: 600;
  color: var(--dashboard-text-primary);
  font-size: 0.875rem;
  margin-bottom: var(--dashboard-space-1);
}

.activity-desc {
  color: var(--dashboard-text-secondary);
  font-size: 0.8rem;
  line-height: 1.4;
  margin-bottom: var(--dashboard-space-2);
}

.activity-time {
  color: var(--dashboard-text-muted);
  font-size: 0.75rem;
  font-weight: 500;
}

.activity-item:hover {
  background: var(--dashboard-bg);
}

.activity-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.activity-content {
  flex: 1 1;
}

.activity-title {
  font-weight: 500;
  color: var(--dashboard-text-primary);
  margin: 0 0 var(--dashboard-space-1) 0;
  font-size: 0.875rem;
}

.activity-description {
  font-size: 0.75rem;
  color: var(--dashboard-text-muted);
  margin: 0;
}

.activity-time {
  font-size: 0.75rem;
  color: var(--dashboard-text-muted);
  white-space: nowrap;
}

/* Buttons */
.btn-primary {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border: none;
  padding: var(--dashboard-space-3) var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: var(--dashboard-space-2);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--dashboard-shadow-lg);
}

/* Logout Button */
.logout-btn {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
  width: 100%;
  padding: var(--dashboard-space-3) var(--dashboard-space-4);
  margin-top: var(--dashboard-space-3);
  background: transparent;
  border: 1px solid var(--dashboard-border);
  border-radius: var(--dashboard-radius-lg);
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background: var(--dashboard-error);
  color: white;
  border-color: var(--dashboard-error);
}

.logout-btn svg {
  width: 16px;
  height: 16px;
}

/* Header Content */
.header-content {
  margin-bottom: var(--dashboard-space-6);
}

.header-content .header-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text-primary);
  margin: 0 0 var(--dashboard-space-4) 0;
  line-height: 1.2;
  display: block;
}

.header-content .header-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--dashboard-primary);
  margin: 0 0 var(--dashboard-space-3) 0;
  line-height: 1.3;
  display: block;
}

.header-content .header-description {
  font-size: 1rem;
  color: var(--dashboard-text-secondary);
  margin: 0;
  line-height: 1.4;
  display: block;
}

.header-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--dashboard-primary);
  margin: 0 0 var(--dashboard-space-1) 0;
}

.header-description {
  font-size: 1rem;
  color: var(--dashboard-text-secondary);
  margin: 0;
  line-height: 1.5;
}

/* Section Headers */
.section-header {
  margin-bottom: var(--dashboard-space-4);
}

.section-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--dashboard-text-primary);
  margin: 0;
}

/* Page Content */
.page-content {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  overflow: hidden;
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--dashboard-space-16);
  gap: var(--dashboard-space-4);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--dashboard-border);
  border-top: 3px solid var(--dashboard-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner p {
  color: var(--dashboard-text-secondary);
  font-weight: 500;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .dashboard-content-grid {
    grid-template-columns: 1fr;
    gap: var(--dashboard-space-4);
  }
  
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }
  
  .quick-actions-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }
}

@media (max-width: 1024px) {
  .clean-sidebar {
    width: 260px;
  }
  
  .dashboard-main {
    padding: var(--dashboard-space-6);
  }
  
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--dashboard-space-4);
  }
  
  .header-title {
    font-size: 1.75rem;
  }
  
  .header-subtitle {
    font-size: 1.125rem;
  }
}

/* Desktop: Show sidebar brand */
@media (min-width: 769px) {
  .mobile-header {
    display: none;
  }
  
  .clean-sidebar {
    position: static;
    width: 280px;
    height: auto;
  }
  
  .sidebar-brand {
    display: flex !important;
    align-items: center;
    gap: var(--dashboard-space-3);
    margin-bottom: var(--dashboard-space-8);
    padding-bottom: var(--dashboard-space-6);
    border-bottom: 1px solid var(--dashboard-border);
  }
  
  .clean-dashboard {
    padding-top: 0;
  }
  
  .dashboard-main {
    margin-left: 0;
    margin-top: 0;
  }
}

@media (max-width: 768px) {
  .mobile-header {
    display: flex;
  }

  .mobile-menu-toggle {
    display: block;
    position: static;
    z-index: 1003;
  }

  .clean-dashboard {
    flex-direction: column;
    padding-top: 60px;
    height: 100vh;
    overflow: hidden;
  }
  
  .clean-sidebar {
    position: fixed;
    top: 60px;
    left: -100%;
    width: 280px;
    height: calc(100vh - 60px);
    flex-direction: column;
    padding: var(--dashboard-space-6);
    overflow-y: auto;
    border-right: 1px solid var(--dashboard-border);
    z-index: 1000;
    transition: left 0.3s ease;
    background: var(--dashboard-bg-primary);
    backdrop-filter: blur(20px);
  }
  
  .clean-sidebar.show {
    left: 0;
  }
  
  .sidebar-brand {
    display: none; /* Hide brand in mobile since we have mobile header */
  }
  
  .sidebar-nav {
    flex-direction: column;
    gap: var(--dashboard-space-2);
    flex: 1 1;
    padding-top: var(--dashboard-space-2);
  }
  
  .nav-item {
    white-space: nowrap;
    flex-shrink: 0;
    padding: var(--dashboard-space-3) var(--dashboard-space-4);
    font-size: 0.9rem;
  }
  
  .nav-label {
    display: block;
  }
  
  .nav-icon {
    font-size: 1.125rem;
  }
  
  .sidebar-user {
    margin-top: auto;
    padding-top: var(--dashboard-space-4);
    border-top: 1px solid var(--dashboard-border);
    margin-bottom: var(--dashboard-space-2);
  }
  
  .user-info {
    display: block;
  }
  
  .logout-btn {
    padding: var(--dashboard-space-3) var(--dashboard-space-4);
    width: 100%;
  }
  
  .logout-btn span {
    display: inline;
  }
  
  .dashboard-main {
    padding: var(--dashboard-space-4);
    margin-left: 0;
    margin-top: 0;
    height: calc(100vh - 60px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .header-title {
    font-size: 1.5rem;
    margin: 0 0 var(--dashboard-space-3) 0 !important;
  }
  
  .header-subtitle {
    font-size: 1rem;
    margin: 0 0 var(--dashboard-space-2) 0 !important;
  }
  
  .header-description {
    font-size: 0.875rem;
    margin: 0 !important;
  }
  
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: var(--dashboard-space-3);
  }
  
  .stat-card {
    padding: var(--dashboard-space-4);
    flex-direction: column;
    text-align: center;
    gap: var(--dashboard-space-3);
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .stat-label {
    font-size: 0.75rem;
  }
  
  .quick-actions-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--dashboard-space-3);
  }
  
  .quick-action-btn {
    padding: var(--dashboard-space-4);
  }
  
  .action-icon {
    width: 40px;
    height: 40px;
  }
  
  .quick-action-btn span {
    font-size: 0.8rem;
  }
  
  .activity-item {
    padding: var(--dashboard-space-3);
    flex-direction: column;
    text-align: center;
    gap: var(--dashboard-space-2);
  }
  
  .activity-icon {
    width: 32px;
    height: 32px;
    align-self: center;
  }
}

@media (max-width: 480px) {
  .dashboard-main {
    padding: var(--dashboard-space-3);
    height: calc(100vh - 60px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .quick-actions-grid {
    grid-template-columns: 1fr;
  }
  
  .header-title {
    font-size: 1.375rem;
    margin: 0 0 var(--dashboard-space-2) 0 !important;
  }
  
  .header-subtitle {
    font-size: 0.9rem;
    margin: 0 0 var(--dashboard-space-2) 0 !important;
  }
  
  .header-description {
    font-size: 0.8rem;
    margin: 0 !important;
  }
  
  .sidebar-brand {
    padding-right: var(--dashboard-space-3);
    margin-right: var(--dashboard-space-3);
  }
  
  .nav-item {
    padding: var(--dashboard-space-2);
  }
  
  .sidebar-user {
    padding-left: var(--dashboard-space-3);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/clean-dashboard.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAGjC;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;;EAE1B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;;EAE/B,gBAAgB;EAChB,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;;EAE/B,sBAAsB;EACtB,2BAA2B;EAC3B,sDAAsD;EACtD,4FAA4F;EAC5F,8FAA8F;;EAE9F,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;;EAE1B,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,mEAAmE;AACrE;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,uCAAuC;EACvC,gDAAgD;EAChD,aAAa;EACb,mCAAmC;EACnC,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yCAAyC;EACzC,yCAAyC;EACzC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+FAA+F;EAC/F,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,4DAA4D,EAAE;EACnE,MAAM,0DAA0D,EAAE;EAClE,OAAO,0DAA0D,EAAE;AACrE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,oGAAoG;EACpG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0DAA0D;EAC1D,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iGAAiG;EACjG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iHAAiH;EACjH,kBAAkB;EAClB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,8EAA8E;EAC9E,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,iGAAiG;EACjG,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,0DAA0D;EAC1D,6DAA6D;EAC7D,yCAAyC;EACzC,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,8EAA8E;EAC9E,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iGAAiG;EACjG,YAAY;EACZ,YAAY;EACZ,0DAA0D;EAC1D,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,0DAA0D;EAC1D,oCAAoC;EACpC,uBAAuB;EACvB,yCAAyC;EACzC,yCAAyC;EACzC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,8CAA8C;EAC9C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2DAA2D;IAC3D,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,uCAAuC;IACvC,wCAAwC;IACxC,gDAAgD;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;IAChB,+CAA+C;IAC/C,aAAa;IACb,0BAA0B;IAC1B,uCAAuC;IACvC,2BAA2B;EAC7B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa,EAAE,qDAAqD;EACtE;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,SAAO;IACP,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,0DAA0D;IAC1D,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,qCAAqC;IACrC,6CAA6C;IAC7C,uCAAuC;EACzC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0DAA0D;IAC1D,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,iDAAiD;EACnD;;EAEA;IACE,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,2DAA2D;IAC3D,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,0BAA0B;IAC1B,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;IACjB,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;AACF","sourcesContent":["/* Clean Modern Dashboard Theme */\n@import '../styles/corporate-theme.css';\n\n:root {\n  /* Modern Dashboard Colors */\n  --dashboard-primary: #6366f1;\n  --dashboard-primary-light: #818cf8;\n  --dashboard-secondary: #8b5cf6;\n  --dashboard-accent: #f59e0b;\n  --dashboard-success: #10b981;\n  --dashboard-warning: #f59e0b;\n  --dashboard-error: #ef4444;\n  \n  /* Background Colors */\n  --dashboard-bg: #f8fafc;\n  --dashboard-card-bg: #ffffff;\n  --dashboard-sidebar-bg: #ffffff;\n  \n  /* Text Colors */\n  --dashboard-text-primary: #1e293b;\n  --dashboard-text-secondary: #64748b;\n  --dashboard-text-muted: #94a3b8;\n  \n  /* Borders & Shadows */\n  --dashboard-border: #e2e8f0;\n  --dashboard-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --dashboard-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --dashboard-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  \n  /* Spacing */\n  --dashboard-space-1: 0.25rem;\n  --dashboard-space-2: 0.5rem;\n  --dashboard-space-3: 0.75rem;\n  --dashboard-space-4: 1rem;\n  --dashboard-space-5: 1.25rem;\n  --dashboard-space-6: 1.5rem;\n  --dashboard-space-8: 2rem;\n  --dashboard-space-10: 2.5rem;\n  --dashboard-space-12: 3rem;\n  --dashboard-space-16: 4rem;\n  \n  /* Border Radius */\n  --dashboard-radius-sm: 0.375rem;\n  --dashboard-radius-md: 0.5rem;\n  --dashboard-radius-lg: 0.75rem;\n  --dashboard-radius-xl: 1rem;\n  --dashboard-radius-2xl: 1.5rem;\n}\n\n/* Clean Dashboard Layout */\n.clean-dashboard {\n  display: flex;\n  min-height: 100vh;\n  background: var(--dashboard-bg);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Sidebar Styling */\n.clean-sidebar {\n  width: 280px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-right: 1px solid rgba(226, 232, 240, 0.8);\n  display: flex;\n  flex-direction: column;\n  padding: var(--dashboard-space-6);\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.clean-sidebar::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(180deg, rgba(99, 102, 241, 0.02) 0%, rgba(139, 92, 246, 0.02) 100%);\n  pointer-events: none;\n}\n\n/* Mobile Header */\n.mobile-header {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: var(--dashboard-bg-primary);\n  border-bottom: 1px solid var(--dashboard-border);\n  z-index: 1002;\n  padding: 0 var(--dashboard-space-4);\n  justify-content: space-between;\n  align-items: center;\n  backdrop-filter: blur(20px);\n  box-shadow: var(--dashboard-shadow-sm);\n}\n\n.mobile-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n}\n\n.mobile-logo .brand-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  border-radius: var(--dashboard-radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 700;\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.mobile-logo .brand-text {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  background: var(--dashboard-bg-secondary);\n  border: 1px solid var(--dashboard-border);\n  color: var(--dashboard-text-primary);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: var(--dashboard-space-2);\n  border-radius: var(--dashboard-radius-md);\n  transition: all 0.2s ease;\n  z-index: 1003;\n}\n\n.mobile-menu-toggle:hover {\n  background: var(--dashboard-bg-hover);\n  border-color: var(--dashboard-primary);\n}\n\n.mobile-menu-toggle svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Mobile Sidebar */\n.mobile-sidebar-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.mobile-sidebar-overlay.show {\n  display: block;\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-3);\n  margin-bottom: var(--dashboard-space-8);\n  padding-bottom: var(--dashboard-space-6);\n  border-bottom: 1px solid var(--dashboard-border);\n}\n\n/* Brand Icon with enhanced gradient */\n.brand-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  border-radius: var(--dashboard-radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1rem;\n  font-weight: 700;\n  box-shadow: var(--dashboard-shadow-md);\n  position: relative;\n  overflow: hidden;\n}\n\n.brand-icon::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.3) 50%, transparent 70%);\n  transform: rotate(45deg);\n  animation: shine 3s infinite;\n}\n\n@keyframes shine {\n  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }\n  50% { transform: translateX(100%) translateY(100%) rotate(45deg); }\n  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }\n}\n\n.brand-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--dashboard-text-primary);\n  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Navigation */\n.sidebar-nav {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-2);\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-3);\n  padding: var(--dashboard-space-3) var(--dashboard-space-4);\n  border-radius: var(--dashboard-radius-lg);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--dashboard-text-secondary);\n  font-weight: 500;\n  font-size: 0.875rem;\n  background: transparent;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.nav-item:hover {\n  background: var(--dashboard-bg);\n  color: var(--dashboard-text-primary);\n}\n\n.nav-item.active {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.nav-icon {\n  font-size: 1.25rem;\n}\n\n/* User Profile in Sidebar */\n.sidebar-user {\n  margin-top: auto;\n  padding-top: var(--dashboard-space-6);\n  border-top: 1px solid var(--dashboard-border);\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-3);\n  padding: var(--dashboard-space-3);\n  border-radius: var(--dashboard-radius-lg);\n  transition: background 0.2s ease;\n}\n\n.user-profile:hover {\n  background: var(--dashboard-bg);\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 0.875rem;\n  box-shadow: var(--dashboard-shadow-md);\n  border: 2px solid var(--dashboard-card-bg);\n  position: relative;\n  overflow: hidden;\n}\n\n.user-avatar::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(45deg, var(--dashboard-primary), var(--dashboard-secondary), var(--dashboard-accent));\n  border-radius: 50%;\n  z-index: -1;\n  animation: rotate 3s linear infinite;\n}\n\n@keyframes rotate {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.user-info {\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.user-role {\n  font-size: 0.75rem;\n  color: var(--dashboard-text-muted);\n  margin: 0;\n}\n\n/* Main Content Area */\n.dashboard-main {\n  flex: 1;\n  padding: var(--dashboard-space-8);\n  overflow-y: auto;\n}\n\n/* Header */\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--dashboard-space-8);\n}\n\n.header-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text-primary);\n  margin: 0 0 var(--dashboard-space-3) 0;\n  line-height: 1.2;\n  display: block;\n}\n\n.header-subtitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--dashboard-primary);\n  margin: 0 0 var(--dashboard-space-3) 0;\n  line-height: 1.3;\n  display: block;\n}\n\n.header-description {\n  font-size: 1rem;\n  color: var(--dashboard-text-secondary);\n  margin: 0;\n  line-height: 1.4;\n  display: block;\n}\n\n.header-actions {\n  display: flex;\n  gap: var(--dashboard-space-4);\n  align-items: center;\n}\n\n/* Stats Cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--dashboard-space-6);\n  margin-bottom: var(--dashboard-space-8);\n}\n\n.stat-card {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  padding: var(--dashboard-space-6);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-4);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);\n  border-color: var(--dashboard-primary);\n}\n\n.stat-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--dashboard-radius-xl);\n  background: linear-gradient(135deg, var(--dashboard-bg) 0%, #e2e8f0 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--dashboard-text-secondary);\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  border: 1px solid var(--dashboard-border);\n  transition: all 0.3s ease;\n}\n\n.stat-icon.connected {\n  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);\n  color: white;\n  border-color: var(--dashboard-success);\n}\n\n.stat-card:hover .stat-icon {\n  transform: scale(1.1);\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border-color: var(--dashboard-primary);\n}\n\n.stat-card:hover .stat-icon.connected {\n  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);\n  color: white;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text-primary);\n  line-height: 1;\n  margin-bottom: var(--dashboard-space-1);\n}\n\n.stat-label {\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text-primary);\n  margin: 0 0 var(--dashboard-space-2) 0;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: var(--dashboard-text-secondary);\n  margin: 0;\n}\n\n.stat-change {\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-top: var(--dashboard-space-2);\n}\n\n.stat-change.positive {\n  color: var(--dashboard-success);\n}\n\n.stat-change.negative {\n  color: var(--dashboard-error);\n}\n\n/* Content Grid */\n.dashboard-content-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--dashboard-space-6);\n  margin-bottom: var(--dashboard-space-8);\n}\n\n/* Cards */\n.dashboard-card {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  padding: var(--dashboard-space-6);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--dashboard-space-6);\n}\n\n.card-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  margin: 0;\n}\n\n.card-action {\n  font-size: 0.875rem;\n  color: var(--dashboard-primary);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n/* Quick Actions Section */\n.quick-actions-section {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  padding: var(--dashboard-space-6);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n}\n\n.quick-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--dashboard-space-4);\n  margin-top: var(--dashboard-space-4);\n}\n\n.quick-action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--dashboard-space-3);\n  padding: var(--dashboard-space-6) var(--dashboard-space-4);\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid var(--dashboard-border);\n  border-radius: var(--dashboard-radius-xl);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  color: var(--dashboard-text-primary);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.quick-action-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  transition: left 0.3s ease;\n  z-index: 0;\n}\n\n.quick-action-btn:hover::before {\n  left: 0;\n}\n\n.quick-action-btn:hover {\n  color: white;\n  border-color: var(--dashboard-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.25);\n}\n\n.action-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  border-radius: var(--dashboard-radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.25rem;\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.quick-action-btn:hover .action-icon {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n}\n\n.quick-action-btn span {\n  font-size: 0.875rem;\n  font-weight: 600;\n  position: relative;\n  z-index: 1;\n  transition: all 0.3s ease;\n}\n\n/* Activity Section */\n.activity-section {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  padding: var(--dashboard-space-6);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-3);\n  margin-top: var(--dashboard-space-4);\n}\n\n.activity-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--dashboard-space-4);\n  padding: var(--dashboard-space-4);\n  border-radius: var(--dashboard-radius-lg);\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.activity-item:hover {\n  background: var(--dashboard-bg);\n  border-color: var(--dashboard-border);\n  transform: translateX(4px);\n}\n\n.activity-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--dashboard-bg);\n  color: var(--dashboard-text-secondary);\n  flex-shrink: 0;\n  border: 1px solid var(--dashboard-border);\n}\n\n.activity-icon.connected {\n  background: linear-gradient(135deg, var(--dashboard-success) 0%, #059669 100%);\n  color: white;\n  border-color: var(--dashboard-success);\n}\n\n.activity-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.activity-title {\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  font-size: 0.875rem;\n  margin-bottom: var(--dashboard-space-1);\n}\n\n.activity-desc {\n  color: var(--dashboard-text-secondary);\n  font-size: 0.8rem;\n  line-height: 1.4;\n  margin-bottom: var(--dashboard-space-2);\n}\n\n.activity-time {\n  color: var(--dashboard-text-muted);\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.activity-item:hover {\n  background: var(--dashboard-bg);\n}\n\n.activity-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.activity-content {\n  flex: 1;\n}\n\n.activity-title {\n  font-weight: 500;\n  color: var(--dashboard-text-primary);\n  margin: 0 0 var(--dashboard-space-1) 0;\n  font-size: 0.875rem;\n}\n\n.activity-description {\n  font-size: 0.75rem;\n  color: var(--dashboard-text-muted);\n  margin: 0;\n}\n\n.activity-time {\n  font-size: 0.75rem;\n  color: var(--dashboard-text-muted);\n  white-space: nowrap;\n}\n\n/* Buttons */\n.btn-primary {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border: none;\n  padding: var(--dashboard-space-3) var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  font-weight: 600;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n}\n\n.btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n/* Logout Button */\n.logout-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n  width: 100%;\n  padding: var(--dashboard-space-3) var(--dashboard-space-4);\n  margin-top: var(--dashboard-space-3);\n  background: transparent;\n  border: 1px solid var(--dashboard-border);\n  border-radius: var(--dashboard-radius-lg);\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-btn:hover {\n  background: var(--dashboard-error);\n  color: white;\n  border-color: var(--dashboard-error);\n}\n\n.logout-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Header Content */\n.header-content {\n  margin-bottom: var(--dashboard-space-6);\n}\n\n.header-content .header-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text-primary);\n  margin: 0 0 var(--dashboard-space-4) 0;\n  line-height: 1.2;\n  display: block;\n}\n\n.header-content .header-subtitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--dashboard-primary);\n  margin: 0 0 var(--dashboard-space-3) 0;\n  line-height: 1.3;\n  display: block;\n}\n\n.header-content .header-description {\n  font-size: 1rem;\n  color: var(--dashboard-text-secondary);\n  margin: 0;\n  line-height: 1.4;\n  display: block;\n}\n\n.header-subtitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--dashboard-primary);\n  margin: 0 0 var(--dashboard-space-1) 0;\n}\n\n.header-description {\n  font-size: 1rem;\n  color: var(--dashboard-text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Section Headers */\n.section-header {\n  margin-bottom: var(--dashboard-space-4);\n}\n\n.section-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  margin: 0;\n}\n\n/* Page Content */\n.page-content {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  overflow: hidden;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--dashboard-space-16);\n  gap: var(--dashboard-space-4);\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--dashboard-border);\n  border-top: 3px solid var(--dashboard-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-spinner p {\n  color: var(--dashboard-text-secondary);\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .dashboard-content-grid {\n    grid-template-columns: 1fr;\n    gap: var(--dashboard-space-4);\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  }\n  \n  .quick-actions-grid {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  }\n}\n\n@media (max-width: 1024px) {\n  .clean-sidebar {\n    width: 260px;\n  }\n  \n  .dashboard-main {\n    padding: var(--dashboard-space-6);\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: var(--dashboard-space-4);\n  }\n  \n  .header-title {\n    font-size: 1.75rem;\n  }\n  \n  .header-subtitle {\n    font-size: 1.125rem;\n  }\n}\n\n/* Desktop: Show sidebar brand */\n@media (min-width: 769px) {\n  .mobile-header {\n    display: none;\n  }\n  \n  .clean-sidebar {\n    position: static;\n    width: 280px;\n    height: auto;\n  }\n  \n  .sidebar-brand {\n    display: flex !important;\n    align-items: center;\n    gap: var(--dashboard-space-3);\n    margin-bottom: var(--dashboard-space-8);\n    padding-bottom: var(--dashboard-space-6);\n    border-bottom: 1px solid var(--dashboard-border);\n  }\n  \n  .clean-dashboard {\n    padding-top: 0;\n  }\n  \n  .dashboard-main {\n    margin-left: 0;\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .mobile-header {\n    display: flex;\n  }\n\n  .mobile-menu-toggle {\n    display: block;\n    position: static;\n    z-index: 1003;\n  }\n\n  .clean-dashboard {\n    flex-direction: column;\n    padding-top: 60px;\n    height: 100vh;\n    overflow: hidden;\n  }\n  \n  .clean-sidebar {\n    position: fixed;\n    top: 60px;\n    left: -100%;\n    width: 280px;\n    height: calc(100vh - 60px);\n    flex-direction: column;\n    padding: var(--dashboard-space-6);\n    overflow-y: auto;\n    border-right: 1px solid var(--dashboard-border);\n    z-index: 1000;\n    transition: left 0.3s ease;\n    background: var(--dashboard-bg-primary);\n    backdrop-filter: blur(20px);\n  }\n  \n  .clean-sidebar.show {\n    left: 0;\n  }\n  \n  .sidebar-brand {\n    display: none; /* Hide brand in mobile since we have mobile header */\n  }\n  \n  .sidebar-nav {\n    flex-direction: column;\n    gap: var(--dashboard-space-2);\n    flex: 1;\n    padding-top: var(--dashboard-space-2);\n  }\n  \n  .nav-item {\n    white-space: nowrap;\n    flex-shrink: 0;\n    padding: var(--dashboard-space-3) var(--dashboard-space-4);\n    font-size: 0.9rem;\n  }\n  \n  .nav-label {\n    display: block;\n  }\n  \n  .nav-icon {\n    font-size: 1.125rem;\n  }\n  \n  .sidebar-user {\n    margin-top: auto;\n    padding-top: var(--dashboard-space-4);\n    border-top: 1px solid var(--dashboard-border);\n    margin-bottom: var(--dashboard-space-2);\n  }\n  \n  .user-info {\n    display: block;\n  }\n  \n  .logout-btn {\n    padding: var(--dashboard-space-3) var(--dashboard-space-4);\n    width: 100%;\n  }\n  \n  .logout-btn span {\n    display: inline;\n  }\n  \n  .dashboard-main {\n    padding: var(--dashboard-space-4);\n    margin-left: 0;\n    margin-top: 0;\n    height: calc(100vh - 60px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .header-title {\n    font-size: 1.5rem;\n    margin: 0 0 var(--dashboard-space-3) 0 !important;\n  }\n  \n  .header-subtitle {\n    font-size: 1rem;\n    margin: 0 0 var(--dashboard-space-2) 0 !important;\n  }\n  \n  .header-description {\n    font-size: 0.875rem;\n    margin: 0 !important;\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: var(--dashboard-space-3);\n  }\n  \n  .stat-card {\n    padding: var(--dashboard-space-4);\n    flex-direction: column;\n    text-align: center;\n    gap: var(--dashboard-space-3);\n  }\n  \n  .stat-icon {\n    width: 48px;\n    height: 48px;\n  }\n  \n  .stat-number {\n    font-size: 1.5rem;\n  }\n  \n  .stat-label {\n    font-size: 0.75rem;\n  }\n  \n  .quick-actions-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--dashboard-space-3);\n  }\n  \n  .quick-action-btn {\n    padding: var(--dashboard-space-4);\n  }\n  \n  .action-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .quick-action-btn span {\n    font-size: 0.8rem;\n  }\n  \n  .activity-item {\n    padding: var(--dashboard-space-3);\n    flex-direction: column;\n    text-align: center;\n    gap: var(--dashboard-space-2);\n  }\n  \n  .activity-icon {\n    width: 32px;\n    height: 32px;\n    align-self: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-main {\n    padding: var(--dashboard-space-3);\n    height: calc(100vh - 60px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .quick-actions-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .header-title {\n    font-size: 1.375rem;\n    margin: 0 0 var(--dashboard-space-2) 0 !important;\n  }\n  \n  .header-subtitle {\n    font-size: 0.9rem;\n    margin: 0 0 var(--dashboard-space-2) 0 !important;\n  }\n  \n  .header-description {\n    font-size: 0.8rem;\n    margin: 0 !important;\n  }\n  \n  .sidebar-brand {\n    padding-right: var(--dashboard-space-3);\n    margin-right: var(--dashboard-space-3);\n  }\n  \n  .nav-item {\n    padding: var(--dashboard-space-2);\n  }\n  \n  .sidebar-user {\n    padding-left: var(--dashboard-space-3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
